module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1OCA1OCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNiZmMwYzA7fTwvc3R5bGU+PC9kZWZzPjxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPjxnIGlkPSJMYXllcl8xLTIiIGRhdGEtbmFtZT0iTGF5ZXIgMSI+PHBhdGggZD0iTTI5LDU4QTI5LDI5LDAsMSwwLDAsMjksMjksMjksMCwwLDAsMjksNTgiLz48cG9seWdvbiBjbGFzcz0iY2xzLTEiIHBvaW50cz0iMzcuNzQgMjkgMjMuMDkgMjAuNTQgMjMuMDkgMzcuNDYgMzcuNzQgMjkiLz48L2c+PC9nPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./images/Play.svg
// module id = 170
// module chunks = 0